import LoginForm from './login'
import SignupForm from './registration'
import Wizard from './wizard'

export default class Auth {
  static LoginForm = LoginForm
  static SignupForm = SignupForm
  static Wizard = Wizard
}
